import clsx from 'clsx';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  term: string;
  isCompressed?: boolean;
  children: React.ReactNode;
};
export function DescriptionListItem({
  term,
  isCompressed,
  className,
  children,
  ...props
}: Props): React.JSX.Element {
  return (
    <div
      {...props}
      className={clsx(
        'sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0',
        isCompressed
          ? 'p-2 text-xs'
          : 'p-4 text-sm/6',
        className
      )}
    >
      <dt className="font-medium">{term}</dt>
      <dd className="mt-1 text-slate11 sm:col-span-2 sm:mt-0">{children}</dd>
    </div>
  );
}

DescriptionListItem.displayName = 'DescriptionListItem';
